/**
 * @file
 * The collapsible header tray.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el, iconButton, labelize, onClick } = berTags.dom;

  // Collapsible header tray, the opener turns into an X while open. An
  // optional store (util.store instance) persists the open state ('tools').
  // Each user toggle calls onToggle(open) and dispatches a bubbling
  // 'ber-toolbar:toggle' event so components tied to tray buttons (e.g.
  // the filter panel) can fold away with it.
  components.tray = ({ id, showLabel, hideLabel, store, onToggle }) => {
    const content = el('div', 'ber-tags__tools');
    content.id = id;
    const toggle = iconButton(
      'ber-tags__sort-option ber-tags__tools-toggle',
      showLabel,
      'expand',
    );
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', id);
    const setOpen = (open) => {
      content.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('.ber-icon').className =
        `ber-icon ber-icon--${open ? 'collapse' : 'expand'}`;
      labelize(toggle, open ? hideLabel : showLabel);
    };
    onClick(toggle, (event) => {
      event.stopPropagation();
      const open = !content.classList.contains('is-open');
      setOpen(open);
      if (store) {
        store.write('tools', open);
      }
      if (onToggle) {
        onToggle(open);
      }
      content.dispatchEvent(
        new CustomEvent('ber-toolbar:toggle', {
          bubbles: true,
          detail: { open },
        }),
      );
    });
    if (store && store.read().tools) {
      setOpen(true);
    }
    return { el: content, toggle };
  };
})(Drupal);
